import { Entity } from '@core/api/entity';
import { DataroomNodeTypeDTO } from '@core/dto/dataroom-node.dto';
import { FileObject } from '@core/models/file-object.model';
import { ArraySerializer, Field, Model, PrimitiveSerializer, Type } from '@junte/serialize-ts';

import { DataroomNodeChangeAuthor } from './dataroom-node-change-author.model';
import { DataroomNodeChoice, DataroomNodeChoiceSerializer } from './dataroom-node-choice';

@Model()
export class DataroomNode extends Entity {
  @Field()
  @Type(new ArraySerializer(new DataroomNodeChoiceSerializer()))
  public ancestors: DataroomNodeChoice[];

  @Field()
  @Type(new PrimitiveSerializer())
  public type: DataroomNodeType;

  @Field()
  public name: string;

  @Field()
  @Type(new DataroomNodeChoiceSerializer())
  public parent: DataroomNodeChoice;

  @Field()
  public file: FileObject;

  @Field()
  public comment: string;

  @Field()
  public modifiedBy: DataroomNodeChangeAuthor;

  @Field()
  public modifiedAt: Date;

  @Field()
  public displayInProductSummary: boolean;

  @Field()
  public keyMetric: boolean;

  @Field()
  public regulatoryRequiredDocument: boolean;

  @Field()
  public investorDataRoom!: string;
  @Field()
  public readOnly!: boolean;

  @Field()
  public isDisclaimerAccepted: boolean;

  @Field()
  public aiProcessingStatus: 'pending' | 'processing' | 'completed' | 'failed' ;

  @Field()
  public status: 'loading' | 'failed' | 'completed' | '' | 'notSupported';

  @Field()
  public isCalculating: boolean;

  @Field()
  public aiScore: number;

  public static create(data: Partial<DataroomNode>): DataroomNode {
    return Object.assign(new DataroomNode(), data);
  }
}

export type DataroomNodeType = DataroomNodeTypeDTO;
